// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartCommunityFirstPage{
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%; /* Adjusted to be full width */
  max-width: 100%;
  overflow-y: scroll;
  background-color: rgba(122, 121, 120, 0.5); /* Adjusted rgba value */
  opacity: 1;
  visibility: visible; 
  transition: opacity 0.3s 0s, visibility 0s 0s;
  z-index: 10;
  padding: 20px 20px; /* Adjusted horizontal padding */
}
.StartCommunity {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%; /* Adjusted to be full width */
  max-width: 100%;
  overflow-y: scroll;
  background-color: rgba(122, 121, 120, 0.5); /* Adjusted rgba value */
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s 0s, visibility 0s 0s;
  z-index: 10;
  padding: 30px 20px; /* Adjusted horizontal padding */
}

.StartCommunity-Container {
  display: block;
  width: 100%; /* Adjusted to be full width */
  max-width: 700px; /* Adjusted maximum width for better readability */
  margin: 0 auto;
  z-index: 999;
  background-color: #ffffff;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  opacity: 1;
}
.StartCommunity-ContainerNone {
  display: none;
}
.StartCommunity-Header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.StartCommunity-Header--Title {
  font-size: 20px;
  font-weight: bold;
}
.StartCommunity-Header--Close {
  margin-bottom: auto;
  padding: 3px 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 14px;
  align-self: flex-end;
  background-color: #f3f2f0;
  border: none;
  display: flex;
  justify-content: center;
  font-size: 24px;
  align-items: center;
}
.StartCommunity-Body {
  padding: 10px;
}
.StartCommunity-Body:last-child {
  padding: 0 10px;
}
.StartCommunity-Body--Intialinfo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  width: 90%;
}
@media screen and (min-width: 768px) {
  .StartCommunity-Body--Intialinfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    width: 90%;
  }
}
.StartCommunity-Body--Intialinfo:last-child {
  display: flex;
  justify-content: flex-start;
  padding: 10px 10px 0;
}
.StartCommunity-Body--Intialinfo p {
  font-size: 13px;
}
.StartCommunity-Body--CommunityImage {
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) {
  .StartCommunity-Body--CommunityImage {
    margin-bottom: 0px;
  }
  .StartCommunity-Body--CommunityImage p{
    font-weight: 400;
    margin-left: -10px;
    margin-bottom: 8px;
  }
}
.StartCommunity-CommunityImage {
  position: relative;
  width: 91px;
  height: 91px;
  border: 7px solid #ebf3fb;
  background-color: #fefefe;
  border-radius: 8px;
  display: flex;
}
.StartCommunity-CommunityImage img {
  margin: 5px;
  width: 100%;
}
.Camera-Icon{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  top: 65px;
  left: 60px;
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  background-color: #EFEEED;
}
.Camera-Icon input{
  width: 0px;
}
/* .Camera-Icon img {
} */
.indicatorImportant {
  color: #4795de;
}
@media screen and (min-width: 768px){
  .StartCommunity-Body--CommunityType p{
    font-weight: 400;
    margin-left: -10px;
    margin-bottom: 4px;
    width: 100%;
  }
}
.StartCommunity-PrivateCommunityOptions div {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-left: 20px;
}
.StartCommunity-PrivateCommunityOptions div p {
  font-size: 15px;
  color: #373334c7;
}
.StartCommunity-PrivateCommunityOptions div input {
  margin-right: 20px;
  margin-top: 2px;
  height: 20px;
  width: 20px;
}
.StartCommunity-PrivateCommunityOptions div p span {
  display: block;
  font-size: 14px;
  color: grey;
  margin-left: 0px;
}

.StartCommunity-CommunityOptions div {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.StartCommunity-CommunityOptions div p {
  font-size: 15px;
  color: #373334c7;
}
.StartCommunity-CommunityOptions div input {
  margin-right: 20px;
  margin-top: 2px;
  height: 20px;
  width: 20px;
}
.StartCommunity-CommunityOptions div p span {
  display: block;
  font-size: 14px;
  color: grey;
  margin-left: 0px;
}
.EditInputfeild {
  margin-top: 3px;
}
.EditInputSubfeild {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}
.EditInputSubfeild:nth-of-type(even) {
  margin-left: 0px;
}
@media screen and (min-width: 768px) {
  .EditInputSubfeild:nth-of-type(even) {
    margin-left: 20px;
  }
}


.EmailField input {
  width: 100%;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 7px 11px;
  color: hsl(0, 0%, 20%);
}

.EditInputfeild input {
  width: 100%;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 7px 11px;
  color: hsl(0, 0%, 20%);
}
.EditInputSubfeild input {
  width: 100%;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 7px 11px;
  color:  hsl(0, 0%, 20%);
}
.EditName {
  margin-left: 20px;
  font-size: 15px;
  margin-bottom: 2px;
}

.EditNameDesc {
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 2px;
}
.EditTextfeild {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 10px 16px;
  resize: none;
  color:  hsl(0, 0%, 20%);
}
.address-city-input-main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .address-city-input-main-container {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  font-size: 14px;
}

.EditSelectFeild {
  width: 100%;
  background-color: white;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 11px;
  color:  hsl(0, 0%, 20%);
}
.SubmitPageContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.afterSubmitFirstPage{
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-image: linear-gradient(to right, #2b70baa3, #007bff);
  color: white;
  margin-left: auto;
  cursor: pointer;
  margin-top: -12px;
}
.beforeSubmitFirstPage{
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-color: #98b9d8;
  color: white;
  margin-left: auto;
  cursor: pointer;
  margin-top: -12px;
}
.beforeSubmit {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-color: #98b9d8;
  color: white;
  margin-left: auto;
  cursor: pointer;
  margin-top: 10px;
}
.afterSubmit {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-image: linear-gradient(to right, #2b70baa3, #007bff);
  color: white;
  margin-left: auto;
  cursor: pointer;
  margin-top: 10px;
}
.success-popup{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
}
.success-popup p {
  font-weight: 500;
  font-size: 15px;
  color: green;
  margin-right: 10px;
}
.SubmitPageContainer span {
  display: inline-block;
  margin-left: auto;
  color: gray;
  font-size: 14px;
}
.Second {
  display: none;
}
.Second--active {
  display: block;
}
.phone-number-container{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.EditSubSelectFeild {
  min-width: 40%;
  background-color: white;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 15px;
  padding: 11px;
  margin-right: 15px;
  color:  hsl(0, 0%, 20%);
}
.EditSubSelectFeildOption{
  font-size: 15px;
  color:  hsl(0, 0%, 20%);
}

.EditInputfeild .PhoneTextFeild {
  max-width: 100%;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  padding: 7px 11px;
}
/* @media screen and (max-width: 380px){
  .EditInputfeild .PhoneTextFeild{
    width: 100%;
    margin-top: 10px;
  }
} */
.CommunityGuidlines {
  margin-left: 20px;
  margin-top: 20px;
  font-size: 14px;
}
.community-guidLine-checkbox-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.community-guidLine-checkbox-container input{
  height: 18px;
  width: 18px;
  margin-right: 10px;
}
.community-guidLine-checkbox-container p {
  font-weight: 400;
  font-size: 13px;
  color: #373334c7;
  margin-bottom: 2px;
}
.community-guidLine-checkbox-container p span {
  color: #4795de;
  text-decoration: underline;
}
.CommunityGuidlines div:last-child {
  margin-top: 20px;
}
.EditSelectFeild select {
  width: 80%;
  border: 0;
  background-color: transparent;
  font-size: 18px;
}
.StartCommunityErrorMsg {
  display: block;
  font-size: 12px;
  color: red;
  margin-top: 5px;
  margin-left: 20px;
}
.StartCommunityErrorMsgHidden {
  display: none;
}
.StartCommunity-Info {
  display: flex;
  justify-content: flex-end;
  font-size: 15px;
  color: grey;
}
@media screen and (min-width: 768px){
  .StartCommunity-Info {
    margin-top: -20px;
    padding-right: 20px;
    margin-bottom: -20px;
  }
}
.autocompleteInput {
  border: none;
}

/* Container for the popup content */
.email-exists-popup {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  padding: 10px 0;
}

/* Strong email text */
.email-exists-popup strong {
  font-weight: bold;
}

/* Buttons container */
.popup-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

/* Ok button */
.popup-ok-btn {
  padding: 8px 24px;
  border-radius: 6px;
  border: none;
  background-color: #007bff; /* blue color */
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.popup-ok-btn:hover {
  background-color: #0056b3;
}

/* Cancel button */
.popup-cancel-btn {
  padding: 8px 24px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #f5f5f5;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.popup-cancel-btn:hover {
  background-color: #e0e0e0;
  border-color: #999;
}

/* Optional: text alignment for paragraph */
.email-exists-popup p {
  margin: 0;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Community/Start Communities/StartCommunities.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW,EAAE,8BAA8B;EAC3C,eAAe;EACf,kBAAkB;EAClB,0CAA0C,EAAE,wBAAwB;EACpE,UAAU;EACV,mBAAmB;EAGnB,6CAA6C;EAC7C,WAAW;EACX,kBAAkB,EAAE,gCAAgC;AACtD;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW,EAAE,8BAA8B;EAC3C,eAAe;EACf,kBAAkB;EAClB,0CAA0C,EAAE,wBAAwB;EACpE,UAAU;EACV,mBAAmB;EAGnB,6CAA6C;EAC7C,WAAW;EACX,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,8BAA8B;EAC3C,gBAAgB,EAAE,kDAAkD;EACpE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;GACG;AACH;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;EACzB;AACF;;AAEA;;;EAGE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;EAC/D,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;EAC/D,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;GAKG;AACH;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB,EAAE,eAAe;EAC1C,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,SAAS;EACT,kBAAkB;AACpB","sourcesContent":[".StartCommunityFirstPage{\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%; /* Adjusted to be full width */\r\n  max-width: 100%;\r\n  overflow-y: scroll;\r\n  background-color: rgba(122, 121, 120, 0.5); /* Adjusted rgba value */\r\n  opacity: 1;\r\n  visibility: visible;\r\n  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;\r\n  -moz-transition: opacity 0.3s 0s, visibility 0s 0s; \r\n  transition: opacity 0.3s 0s, visibility 0s 0s;\r\n  z-index: 10;\r\n  padding: 20px 20px; /* Adjusted horizontal padding */\r\n}\r\n.StartCommunity {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%; /* Adjusted to be full width */\r\n  max-width: 100%;\r\n  overflow-y: scroll;\r\n  background-color: rgba(122, 121, 120, 0.5); /* Adjusted rgba value */\r\n  opacity: 1;\r\n  visibility: visible;\r\n  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;\r\n  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;\r\n  transition: opacity 0.3s 0s, visibility 0s 0s;\r\n  z-index: 10;\r\n  padding: 30px 20px; /* Adjusted horizontal padding */\r\n}\r\n\r\n.StartCommunity-Container {\r\n  display: block;\r\n  width: 100%; /* Adjusted to be full width */\r\n  max-width: 700px; /* Adjusted maximum width for better readability */\r\n  margin: 0 auto;\r\n  z-index: 999;\r\n  background-color: #ffffff;\r\n  padding: 10px 20px;\r\n  border-radius: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  opacity: 1;\r\n}\r\n.StartCommunity-ContainerNone {\r\n  display: none;\r\n}\r\n.StartCommunity-Header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.StartCommunity-Header--Title {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n.StartCommunity-Header--Close {\r\n  margin-bottom: auto;\r\n  padding: 3px 8px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  width: 30px;\r\n  height: 30px;\r\n  font-size: 14px;\r\n  align-self: flex-end;\r\n  background-color: #f3f2f0;\r\n  border: none;\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  align-items: center;\r\n}\r\n.StartCommunity-Body {\r\n  padding: 10px;\r\n}\r\n.StartCommunity-Body:last-child {\r\n  padding: 0 10px;\r\n}\r\n.StartCommunity-Body--Intialinfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  padding: 20px;\r\n  width: 90%;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .StartCommunity-Body--Intialinfo {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px;\r\n    width: 90%;\r\n  }\r\n}\r\n.StartCommunity-Body--Intialinfo:last-child {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  padding: 10px 10px 0;\r\n}\r\n.StartCommunity-Body--Intialinfo p {\r\n  font-size: 13px;\r\n}\r\n.StartCommunity-Body--CommunityImage {\r\n  margin-bottom: 10px;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .StartCommunity-Body--CommunityImage {\r\n    margin-bottom: 0px;\r\n  }\r\n  .StartCommunity-Body--CommunityImage p{\r\n    font-weight: 400;\r\n    margin-left: -10px;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n.StartCommunity-CommunityImage {\r\n  position: relative;\r\n  width: 91px;\r\n  height: 91px;\r\n  border: 7px solid #ebf3fb;\r\n  background-color: #fefefe;\r\n  border-radius: 8px;\r\n  display: flex;\r\n}\r\n.StartCommunity-CommunityImage img {\r\n  margin: 5px;\r\n  width: 100%;\r\n}\r\n.Camera-Icon{\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  top: 65px;\r\n  left: 60px;\r\n  width: 30px;\r\n  height: 30px;\r\n  border: 2px solid #fff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  background-color: #EFEEED;\r\n}\r\n.Camera-Icon input{\r\n  width: 0px;\r\n}\r\n/* .Camera-Icon img {\r\n} */\r\n.indicatorImportant {\r\n  color: #4795de;\r\n}\r\n@media screen and (min-width: 768px){\r\n  .StartCommunity-Body--CommunityType p{\r\n    font-weight: 400;\r\n    margin-left: -10px;\r\n    margin-bottom: 4px;\r\n    width: 100%;\r\n  }\r\n}\r\n.StartCommunity-PrivateCommunityOptions div {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  margin-left: 20px;\r\n}\r\n.StartCommunity-PrivateCommunityOptions div p {\r\n  font-size: 15px;\r\n  color: #373334c7;\r\n}\r\n.StartCommunity-PrivateCommunityOptions div input {\r\n  margin-right: 20px;\r\n  margin-top: 2px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n.StartCommunity-PrivateCommunityOptions div p span {\r\n  display: block;\r\n  font-size: 14px;\r\n  color: grey;\r\n  margin-left: 0px;\r\n}\r\n\r\n.StartCommunity-CommunityOptions div {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n}\r\n.StartCommunity-CommunityOptions div p {\r\n  font-size: 15px;\r\n  color: #373334c7;\r\n}\r\n.StartCommunity-CommunityOptions div input {\r\n  margin-right: 20px;\r\n  margin-top: 2px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n.StartCommunity-CommunityOptions div p span {\r\n  display: block;\r\n  font-size: 14px;\r\n  color: grey;\r\n  margin-left: 0px;\r\n}\r\n.EditInputfeild {\r\n  margin-top: 3px;\r\n}\r\n.EditInputSubfeild {\r\n  margin-top: 10px;\r\n  display: inline-block;\r\n  width: 100%;\r\n}\r\n.EditInputSubfeild:nth-of-type(even) {\r\n  margin-left: 0px;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .EditInputSubfeild:nth-of-type(even) {\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n\r\n.EmailField input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 7px 11px;\r\n  color: hsl(0, 0%, 20%);\r\n}\r\n\r\n.EditInputfeild input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 7px 11px;\r\n  color: hsl(0, 0%, 20%);\r\n}\r\n.EditInputSubfeild input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 7px 11px;\r\n  color:  hsl(0, 0%, 20%);\r\n}\r\n.EditName {\r\n  margin-left: 20px;\r\n  font-size: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.EditNameDesc {\r\n  margin-top: 10px;\r\n  margin-left: 20px;\r\n  margin-bottom: 2px;\r\n}\r\n.EditTextfeild {\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 10px 16px;\r\n  resize: none;\r\n  color:  hsl(0, 0%, 20%);\r\n}\r\n.address-city-input-main-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .address-city-input-main-container {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\ninput:focus,\r\ntextarea:focus,\r\nselect:focus {\r\n  outline: none;\r\n  font-size: 14px;\r\n}\r\n\r\n.EditSelectFeild {\r\n  width: 100%;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n  color:  hsl(0, 0%, 20%);\r\n}\r\n.SubmitPageContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n.afterSubmitFirstPage{\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-image: linear-gradient(to right, #2b70baa3, #007bff);\r\n  color: white;\r\n  margin-left: auto;\r\n  cursor: pointer;\r\n  margin-top: -12px;\r\n}\r\n.beforeSubmitFirstPage{\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-color: #98b9d8;\r\n  color: white;\r\n  margin-left: auto;\r\n  cursor: pointer;\r\n  margin-top: -12px;\r\n}\r\n.beforeSubmit {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-color: #98b9d8;\r\n  color: white;\r\n  margin-left: auto;\r\n  cursor: pointer;\r\n  margin-top: 10px;\r\n}\r\n.afterSubmit {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-image: linear-gradient(to right, #2b70baa3, #007bff);\r\n  color: white;\r\n  margin-left: auto;\r\n  cursor: pointer;\r\n  margin-top: 10px;\r\n}\r\n.success-popup{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 10px;\r\n}\r\n.success-popup p {\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  color: green;\r\n  margin-right: 10px;\r\n}\r\n.SubmitPageContainer span {\r\n  display: inline-block;\r\n  margin-left: auto;\r\n  color: gray;\r\n  font-size: 14px;\r\n}\r\n.Second {\r\n  display: none;\r\n}\r\n.Second--active {\r\n  display: block;\r\n}\r\n.phone-number-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.EditSubSelectFeild {\r\n  min-width: 40%;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 15px;\r\n  padding: 11px;\r\n  margin-right: 15px;\r\n  color:  hsl(0, 0%, 20%);\r\n}\r\n.EditSubSelectFeildOption{\r\n  font-size: 15px;\r\n  color:  hsl(0, 0%, 20%);\r\n}\r\n\r\n.EditInputfeild .PhoneTextFeild {\r\n  max-width: 100%;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  padding: 7px 11px;\r\n}\r\n/* @media screen and (max-width: 380px){\r\n  .EditInputfeild .PhoneTextFeild{\r\n    width: 100%;\r\n    margin-top: 10px;\r\n  }\r\n} */\r\n.CommunityGuidlines {\r\n  margin-left: 20px;\r\n  margin-top: 20px;\r\n  font-size: 14px;\r\n}\r\n.community-guidLine-checkbox-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n.community-guidLine-checkbox-container input{\r\n  height: 18px;\r\n  width: 18px;\r\n  margin-right: 10px;\r\n}\r\n.community-guidLine-checkbox-container p {\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  color: #373334c7;\r\n  margin-bottom: 2px;\r\n}\r\n.community-guidLine-checkbox-container p span {\r\n  color: #4795de;\r\n  text-decoration: underline;\r\n}\r\n.CommunityGuidlines div:last-child {\r\n  margin-top: 20px;\r\n}\r\n.EditSelectFeild select {\r\n  width: 80%;\r\n  border: 0;\r\n  background-color: transparent;\r\n  font-size: 18px;\r\n}\r\n.StartCommunityErrorMsg {\r\n  display: block;\r\n  font-size: 12px;\r\n  color: red;\r\n  margin-top: 5px;\r\n  margin-left: 20px;\r\n}\r\n.StartCommunityErrorMsgHidden {\r\n  display: none;\r\n}\r\n.StartCommunity-Info {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  font-size: 15px;\r\n  color: grey;\r\n}\r\n@media screen and (min-width: 768px){\r\n  .StartCommunity-Info {\r\n    margin-top: -20px;\r\n    padding-right: 20px;\r\n    margin-bottom: -20px;\r\n  }\r\n}\r\n.autocompleteInput {\r\n  border: none;\r\n}\r\n\r\n/* Container for the popup content */\r\n.email-exists-popup {\r\n  font-family: Arial, sans-serif;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  color: #333;\r\n  padding: 10px 0;\r\n}\r\n\r\n/* Strong email text */\r\n.email-exists-popup strong {\r\n  font-weight: bold;\r\n}\r\n\r\n/* Buttons container */\r\n.popup-actions {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 15px;\r\n}\r\n\r\n/* Ok button */\r\n.popup-ok-btn {\r\n  padding: 8px 24px;\r\n  border-radius: 6px;\r\n  border: none;\r\n  background-color: #007bff; /* blue color */\r\n  color: #fff;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.popup-ok-btn:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* Cancel button */\r\n.popup-cancel-btn {\r\n  padding: 8px 24px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ccc;\r\n  background-color: #f5f5f5;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.popup-cancel-btn:hover {\r\n  background-color: #e0e0e0;\r\n  border-color: #999;\r\n}\r\n\r\n/* Optional: text alignment for paragraph */\r\n.email-exists-popup p {\r\n  margin: 0;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
